export class StrategyTriggers {
  filterTriggers: string[];
  conditionTriggers: string[];
  entryTriggers: string[];
  exitTriggers: string[];
  isImmediateExit: boolean;
  entryTriggerTimesCount: number;
  entryTriggerContinuous: boolean;
}
